import { render, staticRenderFns } from "./StatusChanges.vue?vue&type=template&id=4d7a81c7&"
import script from "./StatusChanges.vue?vue&type=script&lang=js&"
export * from "./StatusChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports